export enum BankTransactionType {
  DEPOSIT = "bt111111-1111-1111-1111-111111111111",
  WITHDRAWAL = "bt222222-2222-2222-2222-222222222222",
}

export const BankTransactionTypeInfo = {
  [BankTransactionType.DEPOSIT]: { code: "deposit", name: "Deposit" },
  [BankTransactionType.WITHDRAWAL]: { code: "withdrawal", name: "Withdrawal" },
} as const;

export const getBankTransactionTypeCode = (
  value: BankTransactionType,
): string => BankTransactionTypeInfo[value].code;
export const getBankTransactionTypeName = (
  value: BankTransactionType,
): string => BankTransactionTypeInfo[value].name;
